<template>
  <material-card
  :title="$t('components.vuematerialdashboard.core.appbar.benefit_claims_rules')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="list"
  >
    <template v-slot:actions>
      <div style="margin-right: 20px; margin-top: 10px">
        <v-btn
          color="success"
          @click="ruleTypesDialog = true"
          style="margin-right: 10px"
        >
          {{
            $t(
              "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.rules_types"
            )
          }}
        </v-btn>
        <v-btn color="primary" @click="importDialog = true" :loading="loading">
          {{ $t("views.plan_benefit_rules_view.add_update") }}
        </v-btn>
      </div>
    </template>
    <v-container fluid grid-list-md v-if="options && planConfigurations">
      <v-item-group v-if="planConfigurations.length > 0">
        <v-row>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="4"
            lg="3"
            v-for="planConfiguration in planConfigurations"
            :key="planConfiguration.PlanId"
            class="d-flex"
            style="flex-direction: column"
          >
            <!-- <v-item
              @click="
                
              "
            > -->
            <!-- <plan-tile
                :plans="plans"
                :planConfiguration="planConfiguration"
                :healthBenefitCategories="healthBenefitCategories"
                :dentalBenefitCategories="dentalBenefitCategories"
              /> -->
            <plan-tile
              :planName="getPlanName(planConfiguration)"
              :planConfiguration="planConfiguration"
              @click="
                selectedPlanConfiguration = planConfiguration;
                viewDialog = true;
              "
              @deleted="
                snackbar = true;
                loadPlans();
              "
            />
            <!-- </v-item> -->
          </v-col>
        </v-row>
      </v-item-group>
      <v-row v-else>
        <v-col>
          <v-alert type="warning">
            {{ $t("views.plan_benefit_rules_view.no_configuration_found") }}
          </v-alert>
        </v-col>
      </v-row>

      <import-benefit-rules-configuration-dialog
        :model="importDialog"
        :plans="plans"
        @close="importDialog = false"
        @success="
          snackbar = true;
          importDialog = false;
          loadPlans();
        "
        :ruleTypes="ruleTypes"
      />
      <view-plan-benefit-rules-configuration-dialog
        :model="viewDialog"
        :planConfiguration="selectedPlanConfiguration"
        @close="viewDialog = false"
        :planName="getPlanName(selectedPlanConfiguration)"
      />
      <error-handler :error="error" />
      <v-snackbar v-model="snackbar" color="success" :timeout="2500">
        {{ $t("globals.success") }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
    </v-container>
    <v-dialog v-model="loading" scrollable max-width="100px" persistent>
      <v-container fluid grid-list-md>
        <v-layout v-if="loading" row justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <rule-types-dialog
      :model="ruleTypesDialog"
      :ruleTypes="ruleTypes"
      @close="onClose"
    />
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PlanTile from "@/components/PlanBenefitsRules/PlanTile.vue";
import ErrorHandler from "@/components/ErrorHandler.vue";
import ImportBenefitRulesConfigurationDialog from "@/components/PlanBenefitsRules/ImportBenefitRulesConfigurationDialog.vue";
import ViewPlanBenefitRulesConfigurationDialog from "@/components/PlanBenefitsRules/ViewPlanBenefitRulesConfigurationDialog.vue";
import RuleTypesDialog from "@/components/PlanBenefitsRules/RuleTypesDialog.vue";
export default {
  components: {
    PlanTile,
    ErrorHandler,
    ImportBenefitRulesConfigurationDialog,
    ViewPlanBenefitRulesConfigurationDialog,
    RuleTypesDialog,
  },
  data() {
    return {
      plans: [],
      error: null,
      loading: true,
      planConfigurations: null,
      importDialog: false,
      // healthBenefitCategories: [],
      // dentalBenefitCategories: [],
      viewDialog: false,
      selectedPlanConfiguration: null,
      snackbar: false,
      ruleTypesDialog: false,
      ruleTypes: [],
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  mounted() {
    this.loadPlans();
  },
  methods: {
    ...mapActions("claims", [
      "getBrokerPlansForClaims",
      "getPlanBenefitsRulesConfiguration",
      "getRuleTypes",
    ]),
    onClose() {
      this.ruleTypesDialog = false;
    },
    async loadPlans() {
      this.loading = true;
      try {
        this.plans = (
          await this.getBrokerPlansForClaims({
            brokerId: this.$route.params.broker,
          })
        ).data.value;
        this.planConfigurations = (
          await this.getPlanBenefitsRulesConfiguration({
            payload: this.plans.map((o) => o.PlanIdentityId),
          })
        ).data;
        // this.healthBenefitCategories = [
        //   ...new Set(
        //     this.planConfigurations.map((c) =>
        //       c.BenefitRules.filter(
        //         (r) => r.PlanBenefit.Benefit.Coverage === "Health"
        //       ).map((r) => r.PlanBenefit.Benefit.Category)
        //     )
        //   ),
        // ];
        // this.dentalBenefitCategories = [
        //   ...new Set(
        //     this.planConfigurations.map((c) =>
        //       c.BenefitRules.filter(
        //         (r) => r.PlanBenefit.Benefit.Coverage === "Dental"
        //       ).map((r) => r.PlanBenefit.Benefit.Category)
        //     )
        //   ),
        // ];
        this.ruleTypes = (await this.getRuleTypes()).data;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    save(configuration) {
      console.log("save: ", configuration);
    },
    getPlanName(planConfiguration) {
      if (planConfiguration === null || planConfiguration === undefined) {
        return;
      }
      const plan = this.plans.filter(
        (o) => o.PlanIdentityId === planConfiguration.PlanId
      )[0];
      return `${plan.Name} - ${plan.UniqueIdentifier}`;
    },
  },
};
</script>
